import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { AssetsPipe } from '@pipes/assets.pipe';
import { BusService } from '@services/bus.service';
import { ConfigService } from '@services/config.service';
import { EventsService } from '@services/events.service';
import { IdeaRequestService } from '@services/sessions/idea.request.service';

@Component({
  selector: 'app-idea-bar',
  templateUrl: './idea-bar.component.html',
  styleUrls: ['./idea-bar.component.scss'],
})
export class IdeaBarComponent implements OnInit, OnDestroy {
  @Input() showTopic = false;
  @Input() session: Session;
  @Input() idea: Idea;
  @Output() ideaAction = new EventEmitter<Idea>();

  constructor(
    private appConfig: ConfigService,
    private bus: BusService,
    private events: EventsService,
    private ideaRequest: IdeaRequestService,
    private assetsPipe: AssetsPipe,
  ) {}

  get thumbnailImage() {
    return this.assetsPipe.transform(
      this.idea.thumbnail_id || 'image/default_idea_thumbnail.png',
    );
  }

  get isCollaborator() {
    const collaborators = this.idea.collaborators.map(a => a.participant_id);
    return collaborators.includes(this.session.me._id);
  }

  get iFollow() {
    return (
      this.idea.i_follow ||
      this.idea.followers.find(
        follower => follower.participant_id === this.session.me._id,
      )
    );
  }

  get createdBy() {
    const participant = this.session.config.participants.find(
      p => p._id === this.idea.created_by,
    );
    const user = participant ? participant.user : undefined;

    return user;
    // if (user) {
    //   return user.first_name + ' ' + user.name;
    // } else {
    //   return 'unknown';
    // }
  }

  get creationDate() {
    return new Date(this.idea.created_at).toLocaleDateString();
  }

  follow(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.ideaRequest.follow(this.idea, this.session).subscribe(() => {
      if (!this.iFollow) {
        this.idea.i_follow = true;
        this.idea.followers.push({
          __t: 'Follower',
          participant_id: this.session.me._id,
        });

        this.bus.publish(
          this.events.received.action.session.idea.follow.success,
          { idea: this.idea },
        );
      }
    });
  }

  unfollow(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.ideaRequest.unfollow(this.idea, this.session).subscribe(() => {
      this.idea.i_follow = false;
      this.idea.followers = this.idea.followers.filter(
        follower => follower.participant_id !== this.session.me._id,
      );

      this.bus.publish(
        this.events.received.action.session.idea.unfollow.success,
        { idea: this.idea },
      );
    });
  }

  followed(event) {
    if (event.idea._id === this.idea._id) {
      if (!this.iFollow) {
        this.idea.i_follow = true;
        this.idea.followers.push({
          __t: 'Follower',
          participant_id: this.session.me._id,
        });
      }
    }
  }

  unfollowed(event) {
    if (event.idea._id === this.idea._id) {
      if (this.iFollow) {
        this.idea.i_follow = false;
        this.idea.followers = this.idea.followers.filter(
          follower => follower.participant_id !== this.session.me._id,
        );
      }
    }
  }

  ideaClick() {
    this.ideaAction.emit(this.idea);
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.action.session.idea.follow.success,
      this.followed,
      this,
    );
    this.bus.subscribe(
      this.events.received.action.session.idea.unfollow.success,
      this.unfollowed,
      this,
    );
  }

  ngOnDestroy() {
    this.bus.unsubscribe(
      this.events.received.action.session.idea.follow.success,
      this.followed,
    );
    this.bus.unsubscribe(
      this.events.received.action.session.idea.unfollow.success,
      this.unfollowed,
    );
  }

  num(num: number) {
    if (num < 100) {
      return `${num}`;
    } else {
      return '99+';
    }
  }
}
